<template>
  <div class="footer-bar">
    <div class="footer-bar-l">
      <div
        @click="onFooterClick('favorite')"
        class="favorite"
      >
        <Icon
          class="icon"
          :name="isFavorite ? 'favorite-full' : 'favorite-outline'"
        />
        Favorite
      </div>
      <div
        ref="cartRef"
        @click="onFooterClick('cart')"
        class="cart-count"
      >
        <div class="tips">
          {{ cartCount > 99 ? '99+' : cartCount }}
        </div>
        <Icon
          class="icon"
          name="cart-icon-l"
        />
        Cart
      </div>
    </div>
    <div class="footer-bar-r">
      <div
        v-if="hasBoundStore"
        @click="() => onDropshipping(route.params.id)"
        class="button add-cart"
      >
        {{ shippingConfirmed ? 'Push' : 'Quote & Push' }}
      </div>
      <div
        v-else-if="orderEnable"
        @click="handleGetQuote"
        class="button add-cart"
      >
        Get a Quote
      </div>
      <div
        v-else
        @click="applyOrder"
        class="button enable-order-function"
      >
        Start Order
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useLoginModal } from '@/components/Login'
import { useUserStore } from '@/pinia/user'
import { useRouter, useRoute } from 'vue-router'
import { usePlugin } from '@/hooks/usePlugin'
import { addFavorite, removeFavorite } from '@/api/favorite'
import { Icon } from '@/components/Icon'
import { useCartStore } from '@/pinia/cart'
import { buriedPointUtil } from '@/utils/utils'
import { useOrderEnable } from '../../hooks/useOrderEnable'
import { useDropshipping } from '@/components/Dropshipping/useDropshipping'
import { useCalcShip } from '../../hooks/useCalcShip'
import { useGetQuote } from '@/hooks/useGetQuote'

const props = defineProps({
  favorite: {
    type: Boolean,
    default: false
  }
})

const cartRef = ref(null)

const { shippingConfirmed } = useCalcShip()

const { hasBoundStore, onDropshipping } = useDropshipping()

const { enable: orderEnable } = useOrderEnable()

const { openGetQuote } = useGetQuote()

const { $toast } = usePlugin()

const { open: openLoginModal } = useLoginModal()

const cartStore = useCartStore()

const userStore = useUserStore()

const router = useRouter()

const route = useRoute()

const isFavorite = ref(props.favorite)

const cartCount = computed(() => cartStore.cartCount)

const onFooterClick = (type) => {
  if (type === 'favorite') {
    if (!userStore.isLogged) {
      openLoginModal()
      return
    }
    buriedPointUtil({
      eventId: 'HPD208',
      others: {
        type: isFavorite.value ? 'Followed' : 'Follow',
        followKey: route.params.id
      }
    })
    if (isFavorite.value) {
      return onUnFavorite()
    } else {
      return onFavorite()
    }
  } else if (type === 'cart') {
    buriedPointUtil({ eventId: 'MPC202' })
    router.push('/carts')
  }
}

const onUnFavorite = async () => {
  const { code } = await removeFavorite({
    type: 'PRODUCT',
    targetId: route.params.id
  })
  if (code === 200) {
    isFavorite.value = false
  }
}

const onFavorite = async () => {
  const { code } = await addFavorite({
    type: 'PRODUCT',
    userCollectSaveProductVo: {
      offerId: route.params.id
    }
  })
  if (code === 200) {
    isFavorite.value = true
    $toast('Followed product successfully.')
  }
}

const handleGetQuote = () => {
  buriedPointUtil({ eventId: 'HPD209' })
  openGetQuote()
}

const applyOrder = () => {
  buriedPointUtil({ eventId: 'HPD221' })
}

defineExpose({
  cartRef
})

</script>

<style lang='less' scoped>
.footer-bar {
  display: flex;
  justify-content: space-between;
  padding: 12px 12px 16px;
  gap: 12px;

  .footer-bar-l {
    display: flex;
    gap: 8px;
    .favorite, .cart-count {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 44px;
      height: 44px;
      color: #232323;
      font-size: 10px;
      font-family: mon-500;
      .icon {
        font-size: 24px;
      }
    }
    .cart-count {
      position: relative;
      color: #1153d6;
      border-radius: 50%;
      border: 2px solid #1153d6;
      background-color: #F4F7FF;
      .tips {
        position: absolute;
        top: -7px;
        right: -7px;
        padding: 0 6px;
        height: 14px;
        border-radius: 8px;
        border: 1px solid #D25123;
        background-color: #ffd100;
        color: #232323;
        font-size: 10px;
        font-family: mon-500;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .footer-bar-r {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    .button {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      border-radius: 24px;
      color: white;
      font-size: 14px;
      font-family: mon-600;
      // padding: 0 24px;
      max-width: 200px;
      white-space: nowrap;

      &.add-cart, &.enable-order-function {
        background-color: #052784;
      }
    }
  }
}
</style>

<style>
@keyframes h5-cart-bounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>
